import { useState } from 'react'
import { Check } from 'lucide-react'
import {
  Combobox,
  ComboboxContent,
  ComboboxTrigger,
} from 'tailwind-v4/components/popover-combobox'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandList,
} from 'tailwind-v4/components/command'
import { SquareSvgIcon } from '@/ux/icons/square'
import { SwitcherChevron } from './switcher-chevron'
import { useSquareEntitySelection } from './use-square-entity-selection'

/**
 * New-UI Square entity picker — mirrors the VenueSwitcher's combobox pill so it
 * sits naturally beside it in the top bar, with the Square logo inside the
 * trigger (black in light mode / white in dark via --foreground).
 */
export function SquareEntityPicker({ orgId }: { orgId: string }) {
  const [open, setOpen] = useState(false)
  const { integrations, selected, select } = useSquareEntitySelection(orgId)
  if (integrations.length === 0) return null

  return (
    <Combobox open={open} onOpenChange={setOpen}>
      <ComboboxTrigger className="font-medium">
        <SquareSvgIcon className="size-4 shrink-0 text-[var(--foreground)]" />
        <span className="min-w-0 max-w-[160px] truncate">
          {selected?.merchant_name ?? 'Square account'}
        </span>
        <SwitcherChevron />
      </ComboboxTrigger>
      <ComboboxContent>
        <Command shouldFilter={false}>
          <CommandList>
            <CommandEmpty>No Square accounts.</CommandEmpty>
            <CommandGroup>
              {integrations.map((i) => (
                <CommandItem
                  key={i.id}
                  value={i.id}
                  onSelect={() => {
                    select(i.id)
                    setOpen(false)
                  }}
                  className="data-[selected=true]:bg-[var(--accent)] data-[selected=true]:text-[var(--accent-foreground)]"
                >
                  <SquareSvgIcon className="size-4 shrink-0 text-[var(--foreground)]" />
                  <span className="truncate">{i.merchant_name}</span>
                  {i.id === selected?.id ? (
                    <Check className="ml-auto size-4" />
                  ) : null}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </ComboboxContent>
    </Combobox>
  )
}
